export default __webpack_public_path__ + "static/media/tur.0d684fda.png";